// components/ConnectEdge.tsx
import { EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react';

export const ConnectEdge = ({ id, sourceX, sourceY, targetX, targetY }: any) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY
  });

  return (
    <>
      <path
        id={id}
        d={edgePath}
        className="react-flow__edge-path"
        style={{
          stroke: 'blue',
          strokeWidth: 2,
          fill: 'none'
        }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            background: 'white',
            padding: '2px 4px',
            borderRadius: 4,
            border: '1px solid blue',
            color: 'blue'
          }}
        >
          Connect
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
